import Network from 'lib/api/network';
import { cloneDeep } from 'lodash';

export default {
  namespaced: true,

  state: {
    hrisCategories: null,
    // Indicates an enrollment_rules POST is in flight.
    // Components like bonus-milestones-next-event-copy should not resolve while this is true.
    enrollmentRulesPending: false,
  },

  actions: {
    updateEnrollmentRule({ state, commit }, { networkMethod, updatePath, newCategories, argsKey }) {
      const update = (key, value) => {
        commit('update', { module: 'hrisRecipientsRuleSelector', key, value }, { root: true });
      };

      return new Promise((resolve, reject) => {
        const oldCategories = cloneDeep(state.hrisCategories);
        update('hrisCategories', newCategories);
        update('enrollmentRulesPending', true);
        const activeTypes = JSON.stringify(newCategories.filter(c => c.active).map(c => ({ hris_type: c.hris_type, hris_value: c.hris_value })));
        let args = { active_employment_types: activeTypes };
        if (argsKey) {
          args = { [argsKey]: args };
        }
        Network[networkMethod](updatePath, args, {
          success: () => { resolve(true); },
          error: () => {
            update('hrisCategories', oldCategories);
            reject();
          },
          complete: () => { update('enrollmentRulesPending', false); },
        });
      });
    },
  },
};
